import { render } from "./GlycoasparginaseLeukocytes.vue?vue&type=template&id=f4edff6a&scoped=true"
import script from "./GlycoasparginaseLeukocytes.vue?vue&type=script&lang=js"
export * from "./GlycoasparginaseLeukocytes.vue?vue&type=script&lang=js"

import "./GlycoasparginaseLeukocytes.vue?vue&type=style&index=0&id=f4edff6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4edff6a"]])

export default __exports__